export function CrossIcon({ mainClassName, strokeClassName }) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
      viewBox="0 0 24 24"
    >
      <path
        d="M16 8l-4 4 4 4M8 8l4 4-4 4"
        stroke="#505A72"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={strokeClassName}
      />
    </svg>
  );
}

export function GoBackIcon({ mainClassName, strokeClassName }) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
      viewBox="0 0 24 24"
    >
      <path
        d="M14 8l-4 4 4 4"
        stroke="#505A72"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={strokeClassName}
      />
    </svg>
  );
}

export function SelectArrowIcon({ mainClassName, strokeClassName }) {
  return (
    <svg
      width={12}
      height={12}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
      viewBox="0 0 12 12"
    >
      <path
        d="M10 4L6 8 2 4"
        stroke="#505A72"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={strokeClassName}
      />
    </svg>
  );
}

export function TickIcon({ mainClassName, fillClassName }) {
  return (
    <svg
      width={10}
      height={12}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
      viewBox="0 0 10 12"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.404.847c.356.194.534.29.584.46.049.168-.05.343-.248.693L4.815 10.69c-.3.53-.451.796-.69.809-.239.012-.417-.236-.773-.733L.326 6.552c-.235-.327-.352-.49-.321-.664.03-.173.197-.288.53-.518l.158-.108c.333-.23.5-.345.676-.315.177.03.294.194.528.52l1.263 1.76c.356.496.534.744.773.732.24-.013.39-.278.69-.809L8.06 1.085c.198-.35.297-.525.47-.573.171-.048.35.05.706.243l.168.092z"
        fill="#505A72"
        className={fillClassName}
      />
    </svg>
  );
}

export function AddIcon({ mainClassName, fillClassName }) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
      viewBox="0 0 16 16"
    >
      <path
        d="M7.969 15.969a7.673 7.673 0 01-3.078-.625 8.16 8.16 0 01-2.54-1.727 8.159 8.159 0 01-1.726-2.539A7.671 7.671 0 010 8c0-1.089.208-2.112.625-3.07a8.2 8.2 0 011.719-2.547A8.159 8.159 0 014.883.656 7.672 7.672 0 017.96.031c1.088 0 2.114.209 3.078.625a8.132 8.132 0 012.547 1.727 8.133 8.133 0 011.726 2.547c.417.958.626 1.981.626 3.07a7.67 7.67 0 01-.626 3.078 8.159 8.159 0 01-1.726 2.54 8.132 8.132 0 01-2.547 1.726 7.618 7.618 0 01-3.07.625zm0-1.328c.922 0 1.784-.172 2.586-.516a6.76 6.76 0 002.117-1.422 6.588 6.588 0 001.422-2.117A6.495 6.495 0 0014.609 8c0-.922-.171-1.784-.515-2.586a6.697 6.697 0 00-1.43-2.117 6.476 6.476 0 00-2.117-1.422 6.495 6.495 0 00-2.586-.516c-.922 0-1.784.172-2.586.516a6.498 6.498 0 00-2.11 1.422 6.76 6.76 0 00-1.421 2.117A6.581 6.581 0 001.336 8c0 .922.17 1.784.508 2.586a6.759 6.759 0 001.422 2.117 6.76 6.76 0 002.117 1.422 6.494 6.494 0 002.586.516zM4.344 8c0-.198.06-.357.18-.477a.666.666 0 01.492-.187h2.296V5.039c0-.198.06-.36.18-.484a.61.61 0 01.461-.188.64.64 0 01.664.672v2.297h2.305a.63.63 0 01.476.187.63.63 0 01.188.477.61.61 0 01-.188.46.644.644 0 01-.476.18H8.617v2.305c0 .198-.062.36-.187.485a.644.644 0 01-.477.18.624.624 0 01-.46-.18.671.671 0 01-.18-.485V8.641H5.015a.671.671 0 01-.485-.18A.61.61 0 014.344 8z"
        fill="#002272"
        className={fillClassName}
      />
    </svg>
  );
}

export function SortArrowIcon({ mainClassName, fillClassName }) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 16.12l-3.6-3.6v-1.38l3.072 3.06V7.6h1.056v6.6l3.072-3.06v1.38l-3.6 3.6z"
        fill="#505A72"
        className={fillClassName}
      />
    </svg>
  );
}

export function DeleteCrossIcon({ mainClassName, fillClassName }) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
      viewBox="0 0 24 24"
    >
      <path
        d="M10.108 14.08l-.708-.708 1.692-1.692L9.4 9.988l.708-.708 1.692 1.692 1.692-1.692.708.708-1.692 1.692 1.692 1.692-.708.708-1.692-1.692-1.692 1.692z"
        fill="#505A72"
        className={fillClassName}
      />
    </svg>
  );
}

export function EyeIcon({ mainClassName, fillClassName }) {
  return (
    <svg
      className={mainClassName}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="10"
      viewBox="0 0 18 10"
      fill="none"
    >
      <path
        className={fillClassName}
        d="M9.00008 10C8.17449 10 7.39619 9.9043 6.6652 9.71289C5.93421 9.52555 5.25911 9.27713 4.63992 8.96762C4.02072 8.65811 3.46603 8.31602 2.97583 7.94136C2.48563 7.56669 2.06854 7.19202 1.72454 6.81735C1.38484 6.43861 1.12254 6.09041 0.937646 5.77276C0.757047 5.45103 0.666748 5.19243 0.666748 4.99695C0.666748 4.80147 0.757047 4.5449 0.937646 4.22724C1.12254 3.90959 1.38484 3.56343 1.72454 3.18876C2.06854 2.81002 2.48563 2.43331 2.97583 2.05864C3.46603 1.68397 4.02072 1.34189 4.63992 1.03238C5.25911 0.722867 5.93421 0.474445 6.6652 0.287111C7.39619 0.0957035 8.17449 0 9.00008 0C9.83857 0 10.6255 0.0957035 11.3608 0.287111C12.0961 0.474445 12.7733 0.722867 13.3925 1.03238C14.0117 1.34189 14.5642 1.68397 15.0501 2.05864C15.5403 2.43331 15.9553 2.81002 16.295 3.18876C16.6347 3.56343 16.8927 3.90959 17.069 4.22724C17.2453 4.5449 17.3334 4.80147 17.3334 4.99695C17.3334 5.19243 17.2453 5.45103 17.069 5.77276C16.8927 6.09041 16.6347 6.43861 16.295 6.81735C15.9553 7.19202 15.5425 7.56669 15.0566 7.94136C14.5707 8.31602 14.0181 8.65811 13.3989 8.96762C12.7798 9.27713 12.1004 9.52555 11.3608 9.71289C10.6255 9.9043 9.83857 10 9.00008 10ZM9.00653 8.08186C9.45803 8.08186 9.87942 8.00041 10.2707 7.83751C10.6663 7.67461 11.0146 7.45266 11.3156 7.17166C11.6166 6.88658 11.851 6.55875 12.0187 6.18815C12.1907 5.81755 12.2767 5.42252 12.2767 5.00305C12.2767 4.43291 12.1283 3.9157 11.8316 3.45144C11.5392 2.9831 11.1458 2.6125 10.6513 2.33965C10.1568 2.06272 9.60853 1.92425 9.00653 1.92425C8.40024 1.92425 7.84984 2.06272 7.35534 2.33965C6.86085 2.6125 6.46525 2.98106 6.16855 3.44533C5.87616 3.90959 5.72996 4.42883 5.72996 5.00305C5.73426 5.56099 5.88261 6.07412 6.175 6.54246C6.4717 7.00672 6.86515 7.37935 7.35534 7.66035C7.84984 7.94136 8.40024 8.08186 9.00653 8.08186ZM9.00008 6.20037C8.65178 6.20037 8.35294 6.0843 8.10354 5.85217C7.85844 5.61596 7.73589 5.33293 7.73589 5.00305C7.73589 4.67726 7.85844 4.39625 8.10354 4.16005C8.35294 3.92384 8.65178 3.80574 9.00008 3.80574C9.35268 3.80574 9.65153 3.92384 9.89662 4.16005C10.146 4.39625 10.2707 4.67726 10.2707 5.00305C10.2707 5.33293 10.146 5.61596 9.89662 5.85217C9.65153 6.0843 9.35268 6.20037 9.00008 6.20037Z"
        fill="#D1D4DA"
      />
    </svg>
  );
}

export function CrossEyeIcon({ mainClassName, fillClassName }) {
  return (
    <svg
      className={mainClassName}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="10"
      viewBox="0 0 18 10"
      fill="none"
    >
      <path
        className={fillClassName}
        d="M9.00008 9.66364C8.17449 9.66364 7.39619 9.57587 6.6652 9.40034C5.93421 9.22854 5.25911 9.00072 4.63992 8.71688C4.02072 8.43304 3.46603 8.11932 2.97583 7.77573C2.48563 7.43213 2.06854 7.08854 1.72454 6.74494C1.38484 6.39761 1.12254 6.07829 0.937646 5.78698C0.757047 5.49194 0.666748 5.25478 0.666748 5.07551C0.666748 4.8701 0.784997 4.59186 1.0215 4.2408C1.26229 3.886 1.60629 3.50505 2.05349 3.09797C2.50068 2.69088 3.03388 2.30994 3.65307 1.95514L6.00085 3.9887C5.91486 4.15677 5.84821 4.3323 5.80091 4.5153C5.75361 4.6983 5.72996 4.88691 5.72996 5.08111C5.73426 5.59277 5.88261 6.06335 6.175 6.49285C6.4717 6.91861 6.86515 7.26033 7.35534 7.51803C7.84984 7.77573 8.40024 7.90458 9.00653 7.90458C9.22583 7.90458 9.43868 7.88404 9.64508 7.84295C9.85577 7.80187 10.0536 7.74585 10.2385 7.67489L12.0251 9.22107C11.5693 9.35926 11.0877 9.46757 10.5803 9.546C10.0772 9.62442 9.55048 9.66364 9.00008 9.66364ZM14.4696 8.15107L12.0574 6.04468C12.1305 5.89529 12.1842 5.7403 12.2186 5.5797C12.2573 5.41911 12.2767 5.25291 12.2767 5.08111C12.2767 4.55825 12.1283 4.08394 11.8316 3.65818C11.5392 3.22868 11.1458 2.88882 10.6513 2.63859C10.1568 2.38463 9.60853 2.25765 9.00653 2.25765C8.80873 2.25765 8.61738 2.27259 8.43249 2.30247C8.24759 2.33235 8.06914 2.37529 7.89714 2.43132L6.1234 0.896338C6.562 0.769356 7.0221 0.670386 7.50369 0.599426C7.98529 0.528466 8.48409 0.492986 9.00008 0.492986C9.83857 0.492986 10.6255 0.580752 11.3608 0.756285C12.0961 0.928083 12.7733 1.1559 13.3925 1.43974C14.0117 1.72358 14.5642 2.0373 15.0501 2.3809C15.5403 2.72449 15.9553 3.06996 16.295 3.41729C16.6347 3.76088 16.8927 4.07834 17.069 4.36965C17.2453 4.66096 17.3334 4.89624 17.3334 5.07551C17.3334 5.28466 17.2173 5.5629 16.9851 5.91023C16.7572 6.25756 16.4283 6.63103 15.9983 7.03065C15.5683 7.42653 15.0587 7.8 14.4696 8.15107ZM7.0135 5.03069C7.0135 5.00829 7.0135 4.98588 7.0135 4.96347C7.0178 4.93733 7.01995 4.91118 7.01995 4.88504L9.11618 6.70012C9.08608 6.70012 9.05813 6.70199 9.03233 6.70573C9.00653 6.70573 8.98073 6.70573 8.95493 6.70573C8.60233 6.70573 8.27769 6.63103 7.98099 6.48164C7.68859 6.32852 7.45424 6.12497 7.27795 5.87101C7.10165 5.61705 7.0135 5.33694 7.0135 5.03069ZM10.9738 4.96907C10.9738 4.99148 10.9716 5.01389 10.9673 5.0363C10.9673 5.05871 10.9673 5.08111 10.9673 5.10352L8.89688 3.30524C8.92268 3.30151 8.94633 3.29964 8.96783 3.29964C8.99363 3.29964 9.01943 3.29964 9.04523 3.29964C9.40213 3.29964 9.72463 3.37434 10.0127 3.52373C10.3051 3.67312 10.5373 3.87479 10.7093 4.12876C10.8856 4.38272 10.9738 4.66282 10.9738 4.96907ZM13.8956 9.87652L3.37573 0.750683C3.28113 0.668518 3.23383 0.565813 3.23383 0.442567C3.23383 0.315586 3.28113 0.211013 3.37573 0.128849C3.47463 0.0429495 3.59502 0 3.73692 0C3.87882 0 3.99922 0.0429495 4.09812 0.128849L14.6115 9.24908C14.7104 9.33498 14.7599 9.43769 14.7599 9.5572C14.7599 9.67671 14.7104 9.78315 14.6115 9.87652C14.5126 9.96242 14.3922 10.0035 14.2503 9.99977C14.1127 9.99977 13.9945 9.95868 13.8956 9.87652Z"
        fill="#D1D4DA"
      />
    </svg>
  );
}


export function LinkIcon({
  mainClassName,
  strokeClassName,
}) {
  return (
    <svg
      width={12}
      height={12}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
      viewBox="0 0 12 12"
    >
      <path
        d="M8.811 7.232l1.377-1.376a2.86 2.86 0 00-4.044-4.044L4.768 3.19M7.677 4.323L4.323 7.677M3.189 4.768L1.813 6.144a2.86 2.86 0 004.043 4.044L7.232 8.81"
        stroke="#0030DA"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={strokeClassName}
      />
    </svg>
  );
}

export function DownloadIcon({ mainClassName, strokeClassName }) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
    >
      <path
        d="M10 3.75v8.333m0 0l3.333-3.333M10 12.083L6.667 8.75M4.167 15h11.666"
        stroke="#505A72"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={strokeClassName}
      />
    </svg>
  );
}
